import React from "react";

export default function DropdownIcon(): React.JSX.Element {
  return <i className="scd-dropdown-select-icon icon-scd-arrow-down" />;
}
